import { jsx as _jsx } from "react/jsx-runtime";
// KTK-301 — Plain-text editor used by the journalist prompts panel
// and the per-trigger Advanced section's prompt textarea. Wraps
// CodeMirror 6 (via @uiw/react-codemirror) so the cursor and
// selection survive parent re-renders / autosaves — the bare HTML
// textarea was being snapped to the end of the buffer on every save
// because the controlled `value` was getting reset out from under
// the input.
//
// Plain text only: no syntax highlighting, no line numbers, no fold
// gutter. Soft-wrapped, monospace. Theming is driven by CSS rules
// in apps/web/src/index.css scoped to `.ktk-prompt-editor` so the
// editor flips with `data-theme` (light/dark) like the rest of the
// app — no JS-side theme to keep in sync.
//
// The wrapper div is `resize: vertical` so operators can drag the
// bottom-right corner to grow the editor for long prompts.
import { defaultKeymap, history, historyKeymap } from "@codemirror/commands";
import { EditorState } from "@codemirror/state";
import { EditorView, keymap } from "@codemirror/view";
import CodeMirror from "@uiw/react-codemirror";
// Line-height (1.55) * font-size (12px) ≈ 18.6px per line + 20px
// (top + bottom .cm-content padding) = vertical pixels we need to
// hand the wrapper to land at the requested line count.
const LINE_HEIGHT_PX = 18.6;
const VERTICAL_PADDING_PX = 20;
function pxForLines(lines) {
    return Math.round(lines * LINE_HEIGHT_PX + VERTICAL_PADDING_PX);
}
export function PromptEditor({ value, onChange, onBlur, defaultLines = 30, }) {
    const initialHeightPx = pxForLines(defaultLines);
    return (_jsx("div", { className: "ktk-prompt-editor", style: {
            height: initialHeightPx,
            minHeight: pxForLines(8),
            resize: "vertical",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
        }, children: _jsx(CodeMirror, { value: value, onChange: onChange, theme: "none", basicSetup: {
                lineNumbers: false,
                foldGutter: false,
                highlightActiveLine: false,
                highlightActiveLineGutter: false,
                autocompletion: false,
                bracketMatching: false,
                closeBrackets: false,
                searchKeymap: true,
                history: false,
                defaultKeymap: false,
            }, extensions: [
                history(),
                keymap.of([...defaultKeymap, ...historyKeymap]),
                EditorView.lineWrapping,
                EditorState.tabSize.of(2),
                EditorView.domEventHandlers({
                    blur: () => {
                        onBlur?.();
                        return false;
                    },
                }),
            ], height: "100%", style: { flex: 1, minHeight: 0 } }) }));
}
//# sourceMappingURL=PromptEditor.js.map